import { useLanguage } from '../context/LanguageContext';
import { Calendar, Clock, Users, MessageSquare, ArrowRight } from 'lucide-react';

const ServicesSection = () => {
  const { t, language } = useLanguage();

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    {
      title_key: 'service1_title',
      desc_key: 'service1_desc',
      detail_key: 'service1_detail',
      icon: Users,
    },
    {
      title_key: 'service2_title',
      desc_key: 'service2_desc',
      detail_key: 'service2_detail',
      icon: MessageSquare,
    },
  ];

  return (
    <section 
      id="services"
      className="py-20 md:py-28"
      style={{ backgroundColor: 'var(--sand-50)' }}
      data-testid="services-section"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        {/* Section Title */}
        <h2 
          className="text-3xl md:text-4xl text-center mb-12 md:mb-16"
          style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
        >
          {t('services_title')}
        </h2>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8 md:gap-10">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={service.title_key}
                className="bg-white rounded-3xl p-8 md:p-10 shadow-md hover:shadow-xl transition-shadow duration-300"
                data-testid={`service-card-${index}`}
              >
                {/* Icon & Title */}
                <div className="flex items-center gap-4 mb-6">
                  <div 
                    className="w-14 h-14 rounded-2xl flex items-center justify-center"
                    style={{ backgroundColor: 'var(--sage-100)' }}
                  >
                    <Icon size={28} style={{ color: 'var(--sage-600)' }} />
                  </div>
                  <h3 
                    className="text-xl md:text-2xl"
                    style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--charcoal)' }}
                  >
                    {t(service.title_key)}
                  </h3>
                </div>

                {/* Description */}
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {t(service.desc_key)}
                </p>

                {/* Details */}
                <div 
                  className="flex items-center gap-2 text-sm mb-6 p-4 rounded-xl"
                  style={{ backgroundColor: 'var(--sand-50)' }}
                >
                  <Clock size={18} style={{ color: 'var(--sand-600)' }} />
                  <span className="text-gray-700">{t(service.detail_key)}</span>
                </div>

                {/* CTA */}
                <button
                  onClick={scrollToContact}
                  className="flex items-center gap-2 font-medium transition-colors hover:gap-3"
                  style={{ color: 'var(--sage-600)' }}
                  data-testid={`service-cta-${index}`}
                >
                  {t('services_cta')}
                  <ArrowRight size={18} className={language === 'he' ? 'rotate-180' : ''} />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
